import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LoadChatRoom from '../loaders/LoadChatRoom';
import LoadChatSessions from '../loaders/LoadChatSessions';
import LoadParticipants from '../loaders/LoadParticipants';
import InviteToMeetingScreen from '../screens/Meetings/InviteToMeetingScreen';
import EventChatRoom from '../screens/chat/EventChatRoom';
import EventChatSessions from '../screens/chat/EventChatSessions';
import HasData from '../validate/HasData';
import startNetworkingRoutes from './startNetworkingRoutes';
import { useEventChatEnabled } from '../../data/hooks/eventFeatures/useEventChatEnabled';

const CommonSessionRoutes = (props) => (
    <LoadChatRoom sessionId={props.match.params.chatSessionId}>
        <Switch>
            <Route path={`${props.match.path}/invite`} exact component={InviteToMeetingScreen} />
            <Route exact component={EventChatRoom} />
            <Redirect to={props.match.path} />
        </Switch>
    </LoadChatRoom>
);

const existentChatSessionRoutes = (props) => (
    <LoadChatRoom sessionId={props.match.params.chatSessionId}>
        <HasData path={`chat.indexed[${props.match.params.chatSessionId}]`}>
            <CommonSessionRoutes {...props} />
        </HasData>
    </LoadChatRoom>
);

export const innerChatRoutes = (props) => (
    <Switch>
        <Route path={`${props.match.path}/new`} component={CommonSessionRoutes} />
        <Route path={`${props.match.path}/:chatSessionId`} component={existentChatSessionRoutes} />
        <Redirect to={'..'} />
    </Switch>
);

export default (props) => {
    const isChatEnabled = useEventChatEnabled();
    if (!isChatEnabled) {
        throw new Error('Chat is disabled for this event');
    }
    return (
        <LoadChatSessions>
            <LoadParticipants eventId={props.match.params.eventId}>
                <Switch>
                    <Route path={`${props.match.path}/start-networking`} component={startNetworkingRoutes} />
                    <Route path={`${props.match.path}/new`} component={CommonSessionRoutes} />
                    <Route path={`${props.match.path}/:chatSessionId`} component={existentChatSessionRoutes} />
                    <Route exact component={EventChatSessions} />
                    <Redirect to={props.match.path} />
                </Switch>
            </LoadParticipants>
        </LoadChatSessions>
    );
};
